<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="isProhibit" label="显示停产产品">
          <el-checkbox v-model="query.isProhibit" size="small" />
        </el-form-item>
        <el-form-item prop="fStockID" label="仓库">
          <el-select
            v-model="query.fStockID"
            style="width: 200px"
            size="small"
            clearable
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in stockList"
              :key="item.fStockID"
              :value="item.fStockID"
              :label="item.fName"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="fICItemID" label="产品">
          <el-select-table
            v-model="query.fICItemID"
            :label.sync="fName"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{ prohibit: false }"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="rowDbClick"
      >
        <el-table-column prop="fNumber" label="产品编码" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fQty" label="库存数" />
        <el-table-column prop="fStock" label="所属仓库" />
        <el-table-column prop="fOrderQty" label=" 已下订单数" />
        <el-table-column prop="fQty_ky" label="可用库存数" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="rowDbClick(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        isProhibit: false,
        fStockID: null,
        fICItemID: null,

        pageIndex: 1,
        pageSize: 20
      },
      fName: '',
      pageRecordTotal: 0,
      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      candown: true,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
    this.getStockEntry()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006006002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/Inventory', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },

    rowDbClick: function(item) {
      console.log(item, 'item')
      this.$router.push({
        path: `/statisticalStatement/inventoryEntry`,
        query: {
          items: item,
          ts: new Date().getTime()
        }
      })
    },

    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/InventoryDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
